import React, { useCallback } from "react";
import { Dialog, DialogContent, useTheme } from "@mui/material";
import { AsyncRoleplayScreen } from "../async-roleplay-screen/async-roleplay-screen";
import { dialogContentStyles, dialogPaperStyles } from "./styles";

interface AsyncRoleplayDialogProps {
  open: boolean;
  sessionId: string;
  onClose: () => void;
}

export const AsyncRoleplayDialog: React.FC<AsyncRoleplayDialogProps> = ({
  open,
  sessionId,
  onClose,
}) => {
  const theme = useTheme();

  const handleClose = useCallback(
    (_event?: {}, reason?: string) => {
      if (reason === "backdropClick") return;
      onClose();
    },
    [onClose],
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen
      PaperProps={{
        sx: dialogPaperStyles(
          theme.palette.mode === "dark" ? "#05070B" : theme.palette.grey[100],
        ),
      }}
    >
      <DialogContent sx={dialogContentStyles}>
        <AsyncRoleplayScreen sessionId={sessionId} onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};
